<template>
    <Loading :loading="$store.state.loading.processing" :text="$store.state.loading.text"></Loading>
</template>

<script>
import Loading from '@/components/loading.vue'

export default {
    components: {
        Loading,
    },
    async created() {
        this.$store.commit('loading/PROCESSING', `Confirming Email...`)
        const {id} = this.$route.params
        await this.axios.post(`${process.env.VUE_APP_NODE_API_HOST}/users/confirm/${id}`)
        this.$store.commit('loading/PROCESSED')
        this.$router.push('/auth/login?confirmed="true"')
    },
}
</script>

<style></style>
